export class MapFilterRequiredData {
    things: boolean;
    locations: boolean;
    alerts: boolean;
    events?: boolean;
}